import { getQASelector } from "./getQASelector";

export default getQASelector;
